import { useCallback } from 'react';

/**
 * Hook for making screen reader announcements
 * Uses a live region to announce messages to assistive technologies
 */
export const useAnnouncement = () => {
  const announce = useCallback((message: string, priority: 'polite' | 'assertive' = 'polite') => {
    const announcer = document.getElementById('announcements');
    if (announcer) {
      // Clear previous announcement
      announcer.textContent = '';
      // Set priority
      announcer.setAttribute('aria-live', priority);
      // Small delay to ensure screen readers pick up the change
      setTimeout(() => {
        announcer.textContent = message;
      }, 100);
    }
  }, []);

  return { announce };
};

